import React from 'react';
import { Provider } from 'react-redux'
import store from '../../store';
import Layout from '../Layout/Layout';
import { INIT, WEBSOCKET_URL } from '../../constants/actionTypes';

class App extends React.Component {
    constructor(props) {
        super(props);
        store.dispatch({type: INIT})
        store.dispatch({type: WEBSOCKET_URL, payload: props.socketUrl})
    }

    render() {
        return (
            <Provider store={store}>
                <Layout {...this.props} />
            </Provider>
        )
    }
}

App.defaultProps = {
    language: 'sv',
    coinMachineUrl: '',
    mapInfo: null,
    externalGeolocation: false,
    labels: {},
    googleMapKey: '',
    socketUrl: '',
    services: []
}

export default App;
